import { render, staticRenderFns } from "./ReportDailyDisaster.vue?vue&type=template&id=2b7876a1&scoped=true"
import script from "./ReportDailyDisaster.vue?vue&type=script&lang=js"
export * from "./ReportDailyDisaster.vue?vue&type=script&lang=js"
import style0 from "./ReportDailyDisaster.vue?vue&type=style&index=0&id=2b7876a1&prod&scoped=true&lang=css"
import style1 from "./ReportDailyDisaster.vue?vue&type=style&index=1&id=2b7876a1&prod&lang=css"
import style2 from "./ReportDailyDisaster.vue?vue&type=style&index=2&id=2b7876a1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7876a1",
  null
  
)

export default component.exports